import { Box, For, Heading, Skeleton, Stack } from '@chakra-ui/react';
import FaceliftText from '@/components/Atoms/FaceliftText';
import CheckoutInvoiceItem from '@/components/Molecules/CheckoutInvoiceItem';
import type { InvoiceCheckoutData } from '@/types/invoice';

export interface InvoiceCartListProps {
	invoices: InvoiceCheckoutData[];
	isLoading: boolean;
	handleViewInvoice: (invoiceNumber: string, clinicQBOId: string) => void;
}

const InvoiceCartList: React.FC<InvoiceCartListProps> = ({
	invoices,
	isLoading,
	handleViewInvoice,
}) => (
	<Box
		boxShadow="sm"
		border="1px solid"
		borderColor={{ base: 'gray.300', _dark: 'gray.600' }}
		p={4}
		borderRadius="md"
	>
		<Heading size="md" mb={4}>
			Invoices Ready for Payment
		</Heading>
		{isLoading ? (
			<Skeleton height="40px" />
		) : invoices.length === 0 ? (
			<FaceliftText>No items in the cart.</FaceliftText>
		) : (
			<Stack>
				<For each={invoices} >
					{(item) => (
						<CheckoutInvoiceItem
							handleViewInvoice={handleViewInvoice}
							invoice={item} key={item.InvoiceID} />
					)}
				</For>
			</Stack>
		)}
	</Box>
);

export default InvoiceCartList;
